import * as React from 'react';
import { useCurrentRefinements } from 'react-instantsearch';

export default function GroupLabel(props) {
  const {items, refine} = useCurrentRefinements(props);
  const {currentGroup} = props;
  const separator = ' | ';

  if (items.length === 0) {
    return null;
  }

  const parts = [];
  let allowedAttributes = [];
  if (currentGroup && currentGroup.labelFields) {
    allowedAttributes = currentGroup.labelFields.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }

  if (allowedAttributes.length < 1) {
    return null;
  }

  const allParts = {};
  for (const item of items) {
    const {refinements} = item;
    for (const refinement of refinements) {
      const {value, attribute} = refinement;
      allParts[attribute] = value;
    }
  }

  for (const attr of allowedAttributes) {
    if (allParts[attr]) {
      parts.push(allParts[attr]);
    }
  }

  return (
    <div>
      {parts.join(separator)}
    </div>
  );
}
